<template>
	<div v-if="event && event.addons.length > 0">
		<v-dialog :fullscreen="isMobile" attach v-model="open" max-width="700px" scrollable>
			<v-card height="50vh;" v-if="getPaymentModalEvent">
				<v-card-title class="modal__title">
					<button class="btn-flat-icon--dark" type="button" @click="open=false">
						<v-icon medium>fal fa-times</v-icon>
					</button>
					<v-spacer></v-spacer>
					<v-icon small style="color: #AAA;">fas fa-lock</v-icon>
					<span class="braintree-secure--text">
						<a href="https://www.braintreegateway.com/merchants/n7kq32c2r76sww2q/verified" target="_blank">Braintree</a> Verified Secure <br>
						256 bit SSL encryption
					</span>
				</v-card-title>
				<v-card-text class="modal__card-text basic-modal-padding">
					<div>
						<v-layout row wrap>
							<v-flex xs12>
								<div class="payment-modal__header mt-3">Confirm Payment</div>
								<p class="payment-modal__subheader error--text mt-3 mb-3" v-if="addonStarted">Warning - This addon has already started. Make sure to ask your host if you can still join after the start time.</p>
								<div class="payment-modal__subheader">This purchase includes ${{event.addons[0].price}} {{event.addons[0].title}} {{event.addons[0].time_slot}} the event from {{event.addons[0].start_time}} to {{event.addons[0].end_time}}</div>
								<p class="payment-modal__subheader mt-3 mb-3"><i>Your card will be charged ${{ event.addons[0].price }}.</i></p>
								<div class="mb-3">

									<p class="payment-modal__small mb-0">*Pro tip: Use your business card to track WRKPRTY as an expense.</p>
									<!-- <v-select
										:items="paymentMethodOptions"
										v-model="selectedPaymentMethod"
										placeholder="Select Payment Method"
										hide-details
										single-line
										bottom
										item-text="text"
										item-value="value"
										class="mb-2"
									></v-select> -->
									<div class="mt-4 mb-3" v-if="paymentMethodOptions.length > 1" style="display: flex; flex-direction: row; justify-content: space-between; flex-wrap: wrap; align-items: center;">
										<div style="display: flex; flex-direction: row; align-items: center; flex-grow: 3;">
											<i style="font-size: 2.0em; display: inline;" class="fal fa-credit-card"></i>&nbsp;&nbsp;&nbsp;&nbsp;
											<p class="payment-modal__method-header mb-0">Payment method:
											<span style="font-size: 0.8em; font-weight: normal;">
												<span v-if="selectedPaymentMethod === 'new'">Adding new payment method</span>
												<span v-else>{{getPaymentMethod}}</span>
											</span>
											</p>
										</div>
										<v-menu left style="flex-grow: 1" class="text-xs-center">
											<v-btn slot="activator" flat class="payment-method-change-button info--text">Change</v-btn>
											<v-list>
												<v-list-tile v-for="item in paymentMethodOptions" :key="item.value" @click="selectedPaymentMethod = item.value">
													<span style="color: #666">{{ item.text }}</span>
												</v-list-tile>
											</v-list>
										</v-menu>
									</div>
									<!-- <v-layout column align-center justify-center v-else-if="selectedPaymentMethod === null" style="width: 100%; height: 250px;">
										<p>Loading</p>
										<i class="fal fa-spinner rotation success--text" style="font-size: 5.0em;"></i>
									</v-layout> -->

									<hosted-fields
										v-show="showHostedFields"
										wrapperClass="constrain2222"
										:authToken="paymentToken"
										:tokenize="tokenize"
										v-on:bthferror="btHFError"
										v-on:bthfpayload="btHFPayload"
										v-on:tokenized="tokenized"
										:collectCardHolderName="false"
										:collectPostalCode="false"
										:enableDataCollector="false"
									></hosted-fields>
								</div>
							</v-flex>
						</v-layout>
					</div>
					<div>
						<div class="text-xs-center">
							<!-- <v-layout v-if="submitStarted" column align-center justify-center style="width: 100%; height: 300px;">
								<p class="mt-3 mb-1">Submitting</p>
								<i class="fal fa-spinner rotation success--text" style="font-size: 5.0em;"></i>
							</v-layout> -->
							<v-btn block class="btn-orange white--text btn-xlarge" :loading="submitStarted || selectedPaymentMethod === null" :disabled="disableSubmitButton" @click="checkout"><span v-if="requiresApproval">Submit for Approval</span><span v-else>Submit Payment</span></v-btn>
							<p class="payment-modal__small mt-3 text-xs-center">By submitting payment you agree to our <a @click="openPaymentTerms">Payment Terms</a></p>
						</div>
						<!-- <v-btn v-else block dark class="success btn-xlarge" :disabled="braintreeError" @click="addPaymentMethod">Add Payment Method</v-btn> -->
						<img v-if="!isMobile" class="event-page-flat-logo" src="/static/images/wrkprty-flattened-logo.png" alt="">
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PaymentForm from '~/components/payment/PaymentForm'
import axios from 'axios'
import btClient from 'braintree-web/client'
import btVault from 'braintree-web/vault-manager'
import HostedFields from '~/components/payment/HostedFields.vue'
// import btDropin from 'braintree-web-drop-in'
import { segmentIdentify, segmentTrack } from '~/plugins/segment'
import { deepCopy } from '~/store/util/util'
import moment from 'moment'

export default {
	data() {
		return {
			dialog: false,
			paymentToken: null,
			dropinOptions: {
				authorization: null,
				selector: '#dropin-container'
			},
			promoCode: "",
			promoValid: false,
			promoValue: 0,
			promoError: false,
			promoErrorMessage: [],
			errorMessage: '',
			dropinInstance: '',
			paymentPayload: '',
			dataCollectorPayload: '',
			wrapperClass: 'constrain',
			collectCardHolderName: true,
			enableDataCollector: true,
			enablePayPal: true,
			paymentMethodNonce: null,
			startingPremium: false,
			submitStarted: false,
			braintreeError: false,
			loadingBraintree: true,
			enteringNewPaymentMethod: false,
			paymentMethods: [],
			selectedPaymentMethod: null,
			tokenize: false
		}
	},
	mounted() {
		// console.log('payment modal mounted')
		if (this.userIsAuthenticated) {
			axios
				.get('/api/v1/payment-token/')
				.then(response => {
					this.paymentToken = response.data
				})
				.catch(error => {
					console.error('Error receiving payment token')
					console.error(error)
				})
		}
	},
	watch: {
		paymentToken(newValue, oldValue) {
			if (newValue !== null) {
				this.dropinOptions.authorization = newValue
				// this.createDropin()
			}
		}
	},
	methods: {
		...mapActions([
			'setEventRSVPSuccessModalEvent',
			'setUserProp',
			'setEventProp',
			'setAllEvents',
			'setGenericModalTitle',
			'setGenericModalText',
			'setTermsPage',
			'setModalOpen',
			'setModalProp',
			'openPurchaseAddonSuccessModal'
		]),
		openPaymentTerms() {
			this.setTermsPage('paymentpolicy')
			this.setModalOpen({ prop: 'termsModal', value: true })
		},
		tokenized() {
			this.tokenize = false
		},
		checkout() {
			if (this.selectedPaymentMethod === 'new') {
				this.tokenize = true
			} else {
				this.submitPayment()
			}
		},
		submitPayment() {
			if (!this.selectedPaymentMethod || this.selectedPaymentMethod === 'new') {
				console.log('No payment nonce')
				this.errorMessage =
					'Error submitting payment.  Please select a payment method and try again.'
			} else {
				this.submitStarted = true
				let buyAddon = false
				if (this.getModalProp('paymentModalAddons') !== null) {
					buyAddon = true
				}
				axios.post('/api/v1/purchase-addon/', { event_id: this.event.pk, payment_method_nonce: this.selectedPaymentMethod }).then((response) => {
					console.log('successful payment')
					console.log(response)
					this.setEventProp({
						uuid: this.event.uuid,
						prop: 'addons',
						value: response.data.event.addons
					})
					segmentTrack('Purchased Addon', {
						event_name: this.event.title,
						event_id: this.event.pk,
						price: this.getPrice
					})
					this.openPurchaseAddonSuccessModal()
					this.setEventRSVPSuccessModalEvent(this.event)
					this.setModalProp({ prop: 'paymentModalAddons', value: null })
				})
				.catch(error => {
					this.submitStarted = false
					this.setModalOpen({ prop: 'genericModal', value: true })
					this.setGenericModalTitle('Error')
					this.setGenericModalText([
						'Payment failed, please refresh page and try again'
					])
					console.log(error)
					console.log(error.response)
				})
			}
		},
		btHFError(message) {
			console.error(message)
			// do something with the error message
		},
		btHFPayload(payload) {
			// console.log(payload)
			this.paymentMethods.push(payload)
			this.selectedPaymentMethod = payload.nonce
			this.submitPayment()
		},
		addPaymentMethod() {
			console.log('addPaymentMethod')
			this.tokenize = true
		},
		createBraintreeVault(token) {
			btClient.create({ authorization: token }, (err, client) => {
				if (err) {
					console.error(err)
					return
				}
				btVault.create(
					{
						client: client
					},
					(err, vm) => {
						if (err) {
							console.error(err)
							return
						}

						vm.fetchPaymentMethods((err, paymentMethods) => {
							if (err) {
								console.error(err)
								return
							}
							// An array of payment methods
							if (paymentMethods.length > 0) {
								this.paymentMethods = paymentMethods
								this.selectedPaymentMethod = paymentMethods[0].nonce
							} else {
								this.selectedPaymentMethod = 'new'
							}
							// console.log(paymentMethods)
						})

						// vm.request({
						// 	endpoint: 'payment_methods',
						// 	method: 'get',
						// 	data: {
						// 		defaultFirst: 1
						// 	}
						// }, (err, payload) => {
						// 	if (err) {
						// 		console.error(err)
						// 		return
						// 	}

						// 	this.paymentMethods = payload.paymentMethods

						// 	console.log(payload.paymentMethods)
						// })
					}
				)
			})
		}
	},
	computed: {
		...mapGetters([
			'user',
			'getAllEvents',
			'getModalProp',
			'getPaymentModalEvent',
			'getPaymentModalStatus',
			'userIsAuthenticated'
		]),
		addonStarted () {
			let startTimeString = this.event.addons[0].start_time.substring(0, this.event.addons[0].start_time.length - 3)
			let startTimeA = this.event.addons[0].start_time.substring(this.event.addons[0].start_time.length - 2, this.event.addons[0].start_time.length)
			let startTimeHours = parseInt(startTimeString.split(':')[0])
			let startTimeMinutes = parseInt(startTimeString.split(':')[1])
			if (startTimeA === 'am') {
				if (startTimeHours === 12) {
					startTimeHours = 0
				}
			} else if (startTimeA = 'pm') {
				if (startTimeHours !== 12) {
					startTimeHours += 12
				}
			}

			let addonStart = moment()
			addonStart.set('hours', startTimeHours)
			addonStart.set('minutes', startTimeMinutes)
			addonStart.set('seconds', 0)

			return (addonStart < moment())
		},
		requiresApproval() {
			if (this.event.restrictions.approval === 'all_need_approval') {
				return true
			}
			if (this.event.restrictions.approval === 'level_one') {
				if (this.user.past_events) {
					if (this.user.past_events.length === 0) {
						return true
					}
				}
			}
		},
		getPrice() {
			let price = 0.0
			if (this.getModalProp('paymentModalAddons') !== null) {
				if (this.getModalProp('paymentModalAddons').length > 0) {
					price += parseFloat(this.getModalProp('paymentModalAddons')[0].price)
				}
			}
			price += this.event.price
			if (this.promoValid) {
				price = price - (price * this.promoValue)
			}
			return price
		},
		paymentMethodOptions() {
			console.log(this.paymentMethods)
			let results = this.paymentMethods.map(obj => {
				return {
					text: 'Saved ' + obj.details.cardType + ' ' + obj.description,
					value: obj.nonce
				}
			})
			results = results.concat({ text: 'New Payment Method', value: 'new' })
			return results
		},
		getPaymentMethod() {
			return this.paymentMethodOptions.find(obj => {
				return obj.value === this.selectedPaymentMethod
			}).text
		},
		fieldsInvalid() {
			return false
		},
		showHostedFields() {
			if (this.selectedPaymentMethod === 'new') {
				return true
			}
			return false
		},
		disableSubmitButton() {
			if (this.selectedPaymentMethod === null) {
				return true
			}
			if (this.submitStarted) {
				return true
			}
		},
		event() {
			return this.getAllEvents.find(
				obj => String(obj.slug) === String(this.$route.params.slug)
			)
		},
		open: {
			get() {
				if (this.getModalProp('purchaseAddonModal') === true) {
					segmentTrack('Purchase Addon from active-event', {
						event_name: this.event.title,
						event_id: this.event.pk
					})
					this.createBraintreeVault(this.paymentToken)
				}
				return this.getModalProp('purchaseAddonModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'purchaseAddonModal', value: val })
			}
		},
		isMobile() {
			if (this.$vuetify.breakpoint.name === 'xs') {
				return true
			} else {
				return false
			}
		}
	},
	components: {
		PaymentForm,
		HostedFields
	}
}
</script>

<style lang="scss">
@-webkit-keyframes rotation {
	from {
		-webkit-transform: rotate(0deg);
	}
	to {
		-webkit-transform: rotate(359deg);
	}
}
.rotation {
	-webkit-animation: rotation 2s infinite linear;
}
.padding {
	padding: 24px;
}
.payment-modal {
	color: #444;
	&__header {
		font-size: 2em;
		margin-bottom: 15px;
	}
	&__subheader {
		color: #666;
		font-size: 1.2em;
	}
	&__small {
		color: #999;
		font-size: 0.9em;
	}
}

.payment-modal__method-header {
	font-size: 1.2em;
	font-weight: bold;
}

.braintree-secure--text {
	margin-left: 10px;
	color: #aaa;
	font-size: 0.6em;
}

.payment-method-change-button {
	width: 60px !important;
	min-width: 60px !important;
	margin: 0 10px 0 10px !important;
	padding: 0 !important;
}

@media screen and (max-width: 600px) {
	.padding {
		padding: 10px;
	}
	.payment-modal {
		&__header {
			font-size: 1.75em;
			margin-bottom: 10px;
		}
		&__subheader {
			font-size: 0.9em;
		}
		&__small {
			font-size: 0.8em;
		}
	}
	.payment-modal__method-header {
		font-size: 0.9em;
	}
}
</style>
